import React from "react";
import "./card-slider.scss";
import CaseCard from "../case-card/case-card";
import { CASES_CONTENT } from "../../constants/content/pages/cases";

type Slide = {
  id: string;
  title: string;
  description: string;
  buttonText: string;
  imageUrl: string;
};

type CardSliderProps = {
  slides: Slide[];
};

const CardSlider: React.FC<CardSliderProps> = ({ slides }) => {
  const findProjectByTitle = (title: string) =>
    CASES_CONTENT.caseProjects.find((p) => p.title === title);

  return (
    <div className="card-slider-container">
      <div className="card-slider-content">
        {slides.map((slide) => {
          const project = findProjectByTitle(slide.title);
          if (!project) return null;
          return (
            <div key={slide.id} className={`slide-item`}>
              <div className="slide-content">
                <CaseCard
                  caseProject={{
                    id: project.id,
                    title: project.title,
                    description: project.description,
                    imageSrc: project.imageSrc,
                    logo: project.logo,
                  }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CardSlider;
